import { getUrlOrigin } from '../common/utils';

let _instance;

class PostMessageManager {
  constructor() {
    if (_instance) {
      return _instance;
    }

    let originWindow;
    if (window.opener) {
      //if opened as a popup
      originWindow = window.opener;
    } else if (window.parent !== window.top) {
      // Meaning the embed.js was opened in an iframe
      originWindow = window.parent;
    } else if (window.top !== window.self) {
      // Meaning the invite was opened in an iframe
      originWindow = window.top.window;
    } else {
      originWindow = window;
    }
    this.remoteOrigin = originWindow;
    _instance = this;
  }

  sendMessage(msgType, payload = {}) {
    const action = msgType;
    this.remoteOrigin.postMessage(
      JSON.stringify({ action, ...payload }),
      getUrlOrigin()
    );
  }
}

export default new PostMessageManager();
